import { MUTUAL_FUND_DETAIL_IMAGE_URL } from '../../../constants'

export const SuggestedHoldingPeriod = () => {
  // return (
  //   <div className='w-full bg-white py-4 px-5 flex gap-4 items-center border-t border-[#EBF2F2]'>
  //     <div className='w-10 h-10'>
  //       <img src={`${MUTUAL_FUND_DETAIL_IMAGE_URL}/suggested-holding-period-icon.svg`} className='w-full h-full' />
  //     </div>
  //     <div className='flex flex-col gap-[1px]'>
  //       <div className='text-[#6A6E6E] font-[400] leading-[150%] text-[13px]'>Suggested Holding Period</div>
  //       <div className='font-[500] text-black'>Coming soon</div>
  //     </div>
  //   </div>
  // )

  return null
}
